<ng-container *ngIf="!item.separator && !item.navCap">
  <a class="cursor-pointer menuLink {{ item.bgcolor }}"
    (click)="onItemClick($event, item)"
    [ngClass]="{
      activeMenu: item.route ? router.isActive(item.route, true) : false,
      'menuLink--expanded': expanded && !isRootLevel() && item.children?.length
    }">
    <i-tabler *ngIf="item.iconName as icon" class="routeIcon icon-18" [name]="icon"></i-tabler>
    {{ item.displayName }}
    <span *ngIf="item.children && item.children.length && !isRootLevel()" class="down-icon d-flex m-l-auto">
      <mat-icon>{{ expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
    </span>
  </a>
</ng-container>

<ng-container *ngIf="item.children">
  <div class="childBox" [class.childBox--open]="!isRootLevel() && expanded">
    <ng-container *ngFor="let child of item.children;">
      <div *ngIf="child.separator" class="nav-dropdown-separator" role="separator"></div>
      <app-horizontal-nav-item
        *ngIf="!child.separator"
        [item]="child"
        [depth]="depth + 1"
        class="ddmenu">
      </app-horizontal-nav-item>
    </ng-container>
  </div>
</ng-container>
